import { mapGetters } from "vuex";

import config from "@/config";

/**
 * Regroupe la logique du bouton d'assistance, identique partout sur le site :
 * lien vers la hotline hors GMBH, copie de l'adresse mail LDE dans le presse-papier en GMBH.
 */
export default {
  computed: {
    ...mapGetters(["isGMBH", "isLogged", "isOnPublicDomain", "urlHotline"]),
    /**
     * Attributs à passer au ButtonClassic d'assistance.
     * @returns {Object} Attributs du bouton.
     */
    btnAssistanceAttr() {
      const attr = {
        label: this.expandedSidebar ? this.$t("general.assistance") : null,
      };

      if (this.isGMBH || !this.isLogged) {
        // En GMBH il n'y a pas de hotline, le bouton copie l'adresse mail au clic
        // En mode visiteur / catalogue public, pas de Hotline
        attr.baliseType = "button";
      } else {
        attr.baliseType = "a";
        attr.extLink = this.urlHotline;
      }
      return attr;
    },
    /**
     * Adresse mail de l'assistance LDE.
     * @returns {String} Adresse mail.
     */
    mailLde() {
      return config.mails.lde;
    },
  },
  methods: {
    /**
     * Attributs du tooltip qui indique l'adresse mail LDE au survol du bouton d'assistance.
     * Masqué hors GMBH par défaut (le bouton mène directement à la hotline, pas besoin de tooltip).
     * @param {Boolean} forceEnabled Si vrai, le tooltip reste actif même hors GMBH (cf. AccesRefuse.vue, où il
     * n'y a pas de lien hotline : le bouton copie toujours l'adresse mail).
     * @returns {Object} Attributs à passer à v-tooltip.
     */
    mailTooltipAttr() {
      return {
        content: this.$t("general.mail-copie-info", { mail: config.mails.publicAssistance }),
        placement: "top",
        delay: { show: 800 },
        disabled: !this.isGMBH && this.isLogged,
      };
    },
    /**
     * Copie un texte dans le presse-papier et affiche un toast de confirmation.
     * @param {String} text Texte à copier.
     * @param {String} title Titre du toast, remplacé par un libellé générique si non fourni.
     */
    customCopyToClipboard(text, title = null) {
      const el = document.createElement("textarea");
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$toast.success({ title: title || this.$t("toast.element-copie-presse-papier") });
    },
    /**
     * Copie l'adresse mail LDE dans le presse-papier, uniquement en GMBH où le bouton n'ouvre pas la hotline.
     */
    copyMailLde() {
      if (!this.isLogged || this.isGMBH) {
        this.customCopyToClipboard(
          config.mails.publicAssistance,
          this.$t("general.email-copiee", 0, { mail: config.mails.publicAssistance })
        );
      }
    },
  },
};
